(ns cms.data
  (:require [clojure.string :as str]))

(defn unnest   
  ([nested-map]
   (into {} (unnest nil nested-map)))
  
  ([prefix nested-value]
   (if (map? nested-value)
     (let [new-prefix
           (when-not (str/blank? prefix)
             (str prefix "/"))]
       (mapcat 
         (fn [[k v]] (unnest (str new-prefix k) v)) 
         nested-value))
     
     (when prefix [[prefix nested-value]]))))

(defn nest [unnested-map]
  (reduce 
    (fn [m [k v]]
      (let [p (str/split k #"/")]
        (if (seq p) 
          (assoc-in m p v)
          m)))
    {}
    unnested-map))

(defn shallow-diff [m1 m2]
  (into 
    {}
    (keep 
      (fn [k]
        (let [a (m1 k)
              b (m2 k)]
          (when (not= (m1 k) (m2 k))
            [k [a b]])))
      (distinct (concat (keys m1) (keys m2))))))
